export enum ErrorCodes {
	INVALID_PARAMS = "0x0004000",
	INVALID_NONCE = "0x0004001",
}
